import { useMemo } from 'react';
import { Tags } from '../../models';

export const getMeaningfulTags = (tags: string = '') => {
  if (!tags) return [];
  return tags
    .split(',')
    .map((t) => t.trim())
    .filter((t) => t !== Tags.FOUND && t.length > 0);
};

export const useMeaningfulTags = (tags: string = '') => {
  return useMemo(() => getMeaningfulTags(tags), [tags]);
};

export const useHasMeaningfulTags = (tags: string = '') => {
  const meaningfulTags = useMeaningfulTags(tags);
  return meaningfulTags.length > 0;
};
